// extracted by mini-css-extract-plugin
export default {"chart":"RecentHashrateChart_chart__9qfBe"};